import { PlayInt } from "interfaces";
import styles from "./Play.module.scss";
import { isDesktop } from "utils/isDesktop";

const Play = ({ onClick, href }: PlayInt) => {
  return isDesktop ? (
    <button
      className={styles["play-container"]}
      onClick={onClick}
      aria-label="play video"
    >
      <div className={styles.play}>
        <p className="bold">PLAY</p>
      </div>
    </button>
  ) : (
    <a
      className={styles["play-container"]}
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="play video"
    >
      <div className={styles.play}>
        <p className="bold">PLAY</p>
      </div>
    </a>
  );
};

export default Play;
